import { useEffect, useState } from "react";
import { PartyPopper } from "lucide-react";
import { api } from "@/lib/api";

export default function WinMarquee({ testid = "win-marquee" }) {
  const [wins, setWins] = useState([]);

  useEffect(() => {
    api.get("/payout-feed").then((r) => setWins(r.data)).catch(() => {});
  }, []);

  if (wins.length === 0) return null;

  return (
    <div data-testid={testid}>
      <p className="font-mono-num text-[10px] tracking-[0.35em] text-[#D4AF37]/70 mb-3 flex items-center gap-2">
        <PartyPopper className="w-3.5 h-3.5" /> WINNERS · 项目收录奖励实时播报
      </p>
      <div className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0A0A0E] py-4">
        <div className="marquee-track items-center gap-5 pr-5">
          {[...wins, ...wins].map((s, i) => (
            <div
              key={i}
              data-testid={i < wins.length ? `win-card-${i}` : undefined}
              className="flex items-center gap-3 shrink-0 border border-[#D4AF37]/20 bg-[#0F0F14] px-5 py-3"
            >
              <span className="font-mono-num text-xs text-gray-400">{s.account}</span>
              <span className="text-xs text-gray-300 max-w-40 truncate">{s.title}</span>
              <span className="font-mono-num text-sm text-gold-grad font-bold whitespace-nowrap">+¥{s.amount.toLocaleString()}</span>
              <span className="text-[10px] text-gray-600 tracking-widest">收录奖励</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
